import { Component, ChangeDetectionStrategy } from '@angular/core';
import { CursorPaginatorComponent } from '@shared/components/data-table/cursor-paginator/cursor-paginator.component';

@Component({
  selector: 'app-dashboard-paginator',
  templateUrl: './dashboard-paginator.component.html',
  styleUrls: ['./dashboard-paginator.component.scss'],
  // TODO(onpush): extends CursorPaginatorComponent, whose public fields are mutated directly via
  // @ViewChild references from sibling data-source classes outside this migration's scope. See
  // cursor-paginator.component.ts for details. Keeping Eager.
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class DashboardPaginatorComponent extends CursorPaginatorComponent {
  constructor() {
    super();
  }
}
